import keymirror from 'keymirror';

const formNames = keymirror({
  changeSurveyName: null,
  changeSurveySlug: null,
  frequencyTimeDay: null,
  frequencyTimeWeek: null,
  frequencyTimeMonth: null,
  repeatVisitorsMessage: null,
  blockedUserMessage: null,
  maxResponsesCount: null,
  buttonContentEdit: null,
  uploadImageFromLink: null,
  imageLibrarySearch: null,
  redirect: null,
  cutOffDate: null,
});

export default formNames;
